import { ExtractedTable } from "../ExtractedTable";
import { MatcherProperties } from "../matchers/Matcher";
import { TableModel, TableModelData } from "../TableModel";
import { ExtractedData } from "./ExtractedData";

export { ExtractedTableData };
class ExtractedTableData extends ExtractedData<
  ExtractedTable,
  TableModelData,
  ExtractedTable
> {
  /**
   * Store each matcher ID against an extraction result.
   */
  _reuseCache: {
    [x in string]: ExtractedTable;
  } = {};

  debug_GetExtracted() {
    let extraction = undefined;
    if (this.getAtIndex() != undefined) {
      const tableModel = new TableModel(this.getAtIndex()!);
      extraction =
        this.index === 0 ? this.extraction : this.fromCache(tableModel);
    }
    return extraction;
  }

  put(
    entry: ExtractedTable | TableModelData<MatcherProperties> | undefined,
  ): boolean {
    if (!entry) {
      return false;
    }

    if (entry.hasOwnProperty("tableModelId")) {
      entry = entry as ExtractedTable;
      if (entry.tableModelId !== "") {
        this._reuseCache[entry.tableModelId] = entry;
      }
    } else if (entry.hasOwnProperty("startOffsetEnd")) {
      return false;
    }

    return false;
  }

  fromCache(entry: TableModel): ExtractedTable | undefined {
    if (this.extraction?.extractedBy(entry)) {
      return this.extraction;
    }
    return this._reuseCache[entry.getModelId()];
  }

  /**
   * Return -1 if entry not found. Add 1 to return value to access reuse array
   */
  findReuseIndex(entry: TableModel): number {
    return this._reuse.findIndex(
      (x) => x && new TableModel(x).getModelId() == entry.getModelId(),
    );
  }

  reuseToExtract(entry: TableModel): ExtractedTable | undefined {
    return this._reuseCache[entry.getModelId()];
  }

  extractToReuse(
    entry: ExtractedTable | TableModelData<MatcherProperties> | undefined,
  ): TableModelData<MatcherProperties> | undefined {
    if (!entry) {
      return undefined;
    }

    if (entry.hasOwnProperty("tableModelId")) {
      return (entry as ExtractedTable).tableTemplateData;
    }

    if (entry.hasOwnProperty("startOffsetEnd")) {
      return entry as TableModelData;
    }

    throw new Error(
      "Invalid extraction to reuse entry " + JSON.stringify(entry),
    );
  }

  setReuse(reuseResults: TableModelData[]) {
    let modifiedReuse = ExtractedTableData.removeDuplicates(reuseResults);
    // remove extracted by extraction
    modifiedReuse = modifiedReuse.filter(
      (r) => !this.extraction?.extractedBy(new TableModel(r)),
    );
    super.setReuse(modifiedReuse);
  }

  removeReuse(table: TableModelData<any>) {
    const tm = new TableModel(table);
    if (this._reuseCache[tm.getModelId()] != undefined) {
      delete this._reuseCache[tm.getModelId()];
    }
    const reuseIndex = this.findReuseIndex(tm);
    if (reuseIndex > -1) {
      this._reuse.splice(reuseIndex, 1);
    }
  }

  static removeDuplicates(
    baseFields: Array<TableModelData | undefined>,
  ): TableModelData[] {
    return baseFields
      .filter((x) => x != undefined)
      .filter(
        (r, i, array) =>
          i ===
          array.findIndex(
            (z) =>
              new TableModel(z!).getModelId() ===
              new TableModel(r!).getModelId(),
          ),
      ) as TableModelData[];
  }
}
